import { call } from 'redux-saga/effects';
import { forecastWeek } from 'store/glue/operation/forecastWeek';
import { sagaWrapper } from 'store/helpers';
import { ActionType } from 'typesafe-actions';

import * as forecastActions from './actions';

// Delegates to the forecastWeek operation. The underlying api.forecastWeek
// call is stubbed today (no backend endpoint in the autogenerated client),
// so this saga effectively no-ops until the endpoint is added.
export function* startForecastWeekSaga(
  action: ActionType<typeof forecastActions.startForecastWeek>,
) {
  function* saga() {
    const { zoneId, date } = action.payload;
    yield call(forecastWeek, { zoneId, date });
  }

  yield call(sagaWrapper, { saga, type: action.type });
}
